import { render } from "./MindMovie.vue?vue&type=template&id=508028a0&scoped=true"
import script from "./MindMovie.vue?vue&type=script&lang=js"
export * from "./MindMovie.vue?vue&type=script&lang=js"

import "./MindMovie.vue?vue&type=style&index=0&id=508028a0&scoped=true&lang=scss"

import exportComponent from "/Users/johnahnz0rs/0-PROJECTS/stackin-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508028a0"]])

export default __exports__